module.exports = __webpack_public_path__ + "static/img/3.c8cc9fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/3.png
// module id = rqFn
// module chunks = 0